import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ApiResultsResponse')
export class ApiResultsResponse<T> {

    @JsonProperty('results', [Object])
    results: T[] = [];
}
